import React from 'react';
import PropTypes from 'prop-types';

import s from './index.module.scss';

const Counter = ({ value }) => {
  let displayValue = `${value}`;

  if (value < 10) {
    displayValue = `0${value}`;
  }

  const CounterElements = displayValue.split('').map((digit) => (
    <div className={s['counter__wrapper']} key={`counter-${digit}`} data-component={'counter'}>
      <div className={`${s['counter__bg']} ${s['counter__bg-upper']}`} />
      <div className={s['counter__digit']}>{digit}</div>
      <div className={`${s['counter__bg']} ${s['counter__bg-lower']}`} />
    </div>
  ));

  return <div className={s.counter}>{CounterElements}</div>;
};

Counter.propTypes = {
  value: PropTypes.number.isRequired,
};

export default Counter;
